import styled from "styled-components";

import { colorsPalettes, fonts } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

export const StyledHeaderText = styled(Text)`
    font-weight: 700;
`;

export const StyledInnerDonutText = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    span:first-child {
        font-weight: 700;
    }

    span:last-child {
        font-family: ${fonts.$dmSansFontFamily};
        font-weight: 400;
        font-size: 10px;
        line-height: 16px;
        color: ${colorsPalettes.carbon[400]};
    }
`;
